import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';

import { Dashboard as DashboardLayout } from 'layouts';

// import { menuTitle, menu } from './_menu';

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing(4)
  },
  item: {
    height: '100%'
  }
});

class Users extends Component {
  render() {
    const { classes, title, children, breadcrumbs } = this.props;

    return (
      <DashboardLayout 
        // specialMenu={menu}
        // specialMenuTitle={menuTitle}
        title={title}
        breadcrumbs={breadcrumbs}
      >

        <div className={classes.root}>
          {children}
        </div>

      </DashboardLayout>
    );
  }
}

export default withStyles(styles)(Users);
